/** @fileoverview Date helper of the student tracker (copy of the teacher's, with the i18n locale). */

const EN_LOCALE = 'en-US'
const PT_LOCALE = 'pt-BR'

/** Maps the i18n language (`en-US`, `pt-BR`, `pt`, …) to a date locale. */
export function dateLocale(language: string | undefined): string {
  return language?.toLowerCase().startsWith('pt') ? PT_LOCALE : EN_LOCALE
}

/** `YYYY-MM-DD` → "Mar 1" / "1 de mar." Empty string for invalid input. */
export function formatDate(dateStr: string | null | undefined, language?: string): string {
  if (!dateStr) return ''
  const date = new Date(`${dateStr}T12:00:00`)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleDateString(dateLocale(language), { day: 'numeric', month: 'short' })
}
